/**
 * Placeholder route table for modules slated for future waves.
 * Each entry produces a `<Route path="…" element={<PlaceholderModule …/>}/>`.
 * Keeping these in data form keeps App.js short and the IA easy to scan.
 */
export const PLACEHOLDER_ROUTES = [
  {
    path: "/identify/opportunities",
    eyebrow: "Identify",
    title: "Opportunity Radar",
    description:
      "Surface ranked AI opportunities by ROI, effort, and risk — and move the highest-impact ideas into governance.",
  },
  {
    path: "/deploy/requests",
    eyebrow: "Deploy",
    title: "Deployment Requests",
    description:
      "Triage requests and progress them through the 5-stage governed approval workflow.",
  },
  {
    path: "/govern/agents",
    eyebrow: "Govern",
    title: "Agent Inventory",
    description:
      "A single source of truth for every AI agent — governed and shadow — across all vendors.",
  },
  {
    path: "/govern/policies",
    eyebrow: "Govern",
    title: "Policy Management",
    description: "Author, version and enforce policies that govern your AI estate.",
  },
  {
    path: "/govern/oversight",
    eyebrow: "Govern",
    title: "Human-in-the-Loop Console",
    description: "Decisions awaiting human review, with SLA timers.",
  },
  {
    path: "/govern/incidents",
    eyebrow: "Govern",
    title: "Incident Register",
    description:
      "Track, triage and resolve AI incidents — with full post-mortem and policy closure loop.",
  },
  {
    path: "/measure/performance",
    eyebrow: "Measure",
    title: "Model Performance & Drift",
    description:
      "Catch quality, latency and hallucination drift before it becomes an incident.",
  },
  {
    path: "/measure/cost",
    eyebrow: "Measure",
    title: "Cost Optimisation",
    description:
      "Measured savings with quality-impact deltas, ready to route into a change request.",
  },
  {
    path: "/measure/benchmark",
    eyebrow: "Measure",
    title: "Benchmarking & Peer Comparison",
    description:
      "Position your AI estate against industry peers — opt-in and anonymised.",
  },
  {
    path: "/compliance",
    eyebrow: "Compliance",
    title: "Compliance Centre",
    description:
      "Coverage and evidence across EU AI Act, NIST AI RMF, ISO 42001, APRA CPS 234, ASIC RG 271, Privacy Act AU and AU AI Ethics Principles.",
  },
  {
    path: "/vendors/integrations",
    eyebrow: "Vendors",
    title: "Integration Hub",
    description:
      "Connect and manage every AI vendor — OpenAI, Anthropic, Bedrock, Vertex, Azure OpenAI and more.",
  },
  {
    path: "/vendors/performance",
    eyebrow: "Vendors",
    title: "Vendor Performance Comparison",
    description:
      "Compare cost, latency and quality across vendors on like-for-like workloads.",
  },
  {
    path: "/reports/packs",
    eyebrow: "Reports",
    title: "Pre-Built Packs",
    description: "One-click signed evidence packs for every framework.",
  },
  {
    path: "/reports/builder",
    eyebrow: "Reports",
    title: "Custom Report Builder",
    description:
      "Compose tenant-scoped reports across agents, costs, incidents, policies, compliance and audit.",
  },
  {
    path: "/reports/scheduled",
    eyebrow: "Reports",
    title: "Scheduled Reports",
    description:
      "Recurring delivery to email, Slack, Teams or SFTP — signed every time.",
  },
  {
    path: "/reports/library",
    eyebrow: "Reports",
    title: "Generated Reports Library",
    description:
      "Every ALGOS-generated document, with verifiable signatures and the TRALENEX × ALGOS cover.",
  },
  {
    path: "/settings/users",
    eyebrow: "Settings",
    title: "Users & Roles",
    description: "Manage who can do what — synced from your IdP via SCIM.",
  },
  {
    path: "/settings/audit",
    eyebrow: "Settings",
    title: "Audit Log",
    description:
      "Tamper-evident, hash-chained log of every action. Verify chain integrity at any time.",
  },
];
